<script>
import Vue from 'vue';
import { mapActions, mapState } from 'vuex';
import store from '~/base_store';
import MediaModule from '../../store';
import ListGroupSelect from '~/components/list_group/components/list_group_select';
import TagsListSelect from './tags_list_select';
import FoldersListSelect from './folders_list_select';
import TypeListSelect from './type_list_select';
import { assureModuleRegistered } from "~/services/store_service";


export default Vue.component('media-filter', {
    store,

    components: {
        TagsListSelect,
        FoldersListSelect,
        TypeListSelect
    },

    props: {
        showTypes: {
            types: Boolean,
            default: true
        }
    },

    computed: {
        ...mapState('media', {
            isLoading: state => state.isLoading,
            tags: state => state.tags,
            folders: state => state.folders,
            types: state => state.types,
            totalTypeCount: state => state.totalTypeCount,
            activeTags: state => state.activeTags,
            activeFolders: state => state.activeFolders,
            layoutType: state => state.layoutType
        }),

        filterLayout() {
            if (this.layoutType === 'side_folders_tags_types') {
                return [
                    'folders-list-select',
                    'tags-list-select',
                    'type-list-select'
                ]
            } else if (this.layoutType === 'side_types_folders_tags') {
                return [
                    'type-list-select',
                    'folders-list-select',
                    'tags-list-select'
                ]
            } else if (this.showTypes) {
                return [
                    'type-list-select'
                ]
            }
        }
    },

    beforeCreate() {
        assureModuleRegistered(this.$store, 'media', MediaModule);
    },

    methods: {
        folderChange(checked) {
            this.$emit('folderChange', checked);
            this.activeFolders = checked;
        }
    }
});
</script>

<template>
    <div class="vue-media-filter">
        <template v-for="item in filterLayout">
            <component :is="item"></component>
        </template>
    </div>
</template>
